export default "__VITE_ASSET__$HVjNLnR__"